import { useEffect, useState } from "react";
import { navItems } from "../../../mocks/hotNews";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkBase =
    "text-sm whitespace-nowrap transition-colors duration-200 px-3 py-2 rounded-full hover:bg-background-100";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 backdrop-blur-md shadow-sm border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-[1320px] items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-eye-line text-lg"></i>
          </span>
          <span className="font-heading text-xl tracking-wide text-foreground-950">
            看料门<span className="text-primary-500">·</span>
          </span>
        </a>

        <nav className="hidden items-center md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`${linkBase} ${
                scrolled ? "text-foreground-700 hover:text-primary-600" : "text-foreground-100 hover:text-background-50"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            前排订阅
            <i className="ri-arrow-right-up-line text-base"></i>
          </a>
          <button
            type="button"
            aria-label="展开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 text-foreground-800 md:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50/95 px-4 py-4 backdrop-blur-md md:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="flex items-center gap-2 rounded-xl bg-background-100 px-4 py-3 text-sm font-medium text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
              >
                <i className="ri-arrow-right-s-line text-primary-500"></i>
                {item.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}